import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { Link } from '@tanstack/react-router'
import { CircleHelpIcon, X } from 'lucide-react'

import { HistoryList } from '@/pages/dashboard/applicants/case-detail/ui/history-list/history-list'

import { Button } from '@/components/button/button'

import { useDialog } from '@/lib/hooks/use-dialog'
import { getCaseHistoryListQuery } from '@/lib/queries/business/v1/case/queries'
import { cn } from '@/lib/utils'

import { CaseDetail } from './ui/case-detail'
import { HistoryUsageGuideDialog } from './ui/history-usage-guide-dialog/history-usage-guide-dialog'
import { useFindTargetCase } from './ui/hooks/use-find-target-case'

export const ApplicantCaseDetailPage = () => {
  const { applicantId: pathId, caseNumber } = useParams({
    from: '/_dashboard/applicants/$applicantId/cases/$caseNumber',
  })

  const { data: dataCaseListStatus } = useQuery(getCaseHistoryListQuery(caseNumber))

  const { targetCase } = useFindTargetCase()
  const isUscisCase = targetCase?.applicationType === 'uscis'

  const {
    isDialogOpen: isHistoryUsageGuideDialogOpen,
    openDialog: openHistoryUsageGuideDialog,
    closeDialog: closeHistoryUsageGuideDialog,
  } = useDialog()

  return (
    <>
      <div className="w-[384px] overflow-auto border-l pb-20 shadow-md">
        <div className={cn('flex items-center justify-between', 'px-6 pb-5 pt-12')}>
          <h3 className={cn('flex items-center', 'border-none', 'text-2xl font-semibold')}>
            <span>History</span>
            {isUscisCase && (
              <button type="button" className={cn('ml-2')} onClick={openHistoryUsageGuideDialog}>
                <CircleHelpIcon size={24} fill="#ABAFC9" className={cn('text-white')} />
              </button>
            )}
          </h3>
          <Link to={`/applicants/$applicantId`} params={{ applicantId: pathId }}>
            <Button variant="ghost" size="icon">
              <X size={16} />
            </Button>
          </Link>
        </div>

        <div className={cn('mb-7', 'px-6')}>
          <HistoryList items={dataCaseListStatus ?? []} />
        </div>

        {!!dataCaseListStatus && <CaseDetail />}
      </div>

      {isHistoryUsageGuideDialogOpen && (
        <HistoryUsageGuideDialog open={isHistoryUsageGuideDialogOpen} closeDialog={closeHistoryUsageGuideDialog} />
      )}
    </>
  )
}
